import { render, staticRenderFns } from "./NricFailure.vue?vue&type=template&id=16be1a57&"
import script from "./NricFailure.vue?vue&type=script&lang=js&"
export * from "./NricFailure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports